import axios from 'axios';
import apisUrls from '../urls';

const deleteInfluencerApi = (id) => {
  return axios.delete(`${apisUrls?.deleteInfluencer}?influencer_id=${id}`);
};

export default deleteInfluencerApi;
